import { compact, isEmpty, map, omitBy } from 'lodash';
import moment from 'moment';

import { convertDateFilterValueToDate } from './conversion';
import { getStartAndEndDateForQuickOption } from './quickOptions';

export function applyDateFilter(
  finalFilters: Record<string, unknown>,
  selectedDurationFromUrl: string | string[] | null | undefined,
  foundOnFromUrl: string[] | null | undefined,
  filterKey: string = 'foundOn',
): void {
  // This method computes overlaping dates if selected
  // Eg: (1st Jan - 20th Jan) AND (10th Jan - 15th Jan) query will return data for (10th Jan - 15th Jan) as it is the overlapping date range
  // Eg: (1st Jan - 20th Jan) AND (10th Jan - 25th Jan) query will return data for (10th Jan - 20th Jan) as it is the overlapping date range
  if (!isEmpty(selectedDurationFromUrl) || !isEmpty(foundOnFromUrl)) {
    if (isEmpty(finalFilters[filterKey] as unknown[])) {
      finalFilters[filterKey] = convertDateFilterValueToDate(
        undefined,
        isEmpty(selectedDurationFromUrl)
          ? (foundOnFromUrl as (string | number | null)[])
          : [selectedDurationFromUrl as string],
      );
    } else {
      const [startDateUrl, endDateUrl] = convertDateFilterValueToDate(
        undefined,
        isEmpty(selectedDurationFromUrl)
          ? (foundOnFromUrl as (string | number | null)[])
          : [selectedDurationFromUrl as string],
      ).map((t) => moment(t));

      const [startDateFilter, endDateFilter] = convertDateFilterValueToDate(
        undefined,
        finalFilters[filterKey] as (string | number | null)[],
      ).map((t) => moment(t));

      let startDate, endDate;
      if (startDateFilter.isAfter(startDateUrl)) {
        startDate = startDateFilter;
      } else {
        startDate = startDateUrl;
      }

      if (endDateFilter.isAfter(endDateUrl)) {
        endDate = endDateUrl;
      } else {
        endDate = endDateFilter;
      }

      if (startDate && endDate && startDate.isBefore(endDate)) {
        finalFilters[filterKey] = [
          startDate.utc().format(),
          endDate.utc().format(),
        ];
      } else {
        const error = new Error(
          'Date/Found On range selected at dashboard and widget are completely different',
          { cause: 'Filter' },
        );
        throw error;
      }
    }
  }
}

export function getEffectDateRangeForTimelineCharts(
  widgetRange: (string | number)[] | null | undefined,
  selectedDurationFromUrl: string | string[] | null | undefined,
  rangeFromUrl: string[] | null | undefined,
  plainUtc?: boolean,
): string[] | (string | number)[] {
  const dateFilters = omitBy(
    { foundOn: compact(widgetRange || []) },
    isEmpty,
  ) as Record<string, unknown>;
  applyDateFilter(dateFilters, selectedDurationFromUrl, rangeFromUrl);
  if (!isEmpty(dateFilters.foundOn)) {
    return plainUtc
      ? map(dateFilters.foundOn as string[], (d) => new Date(d).toUTCString())
      : (dateFilters.foundOn as (string | number)[]);
  }
  return [];
}

export function getFindingAPIDurationFilter(
  filters: Record<string, unknown> = {},
  selectedDuration?: string | null,
  startDate?: string | null,
  endDate?: string | null,
): Record<string, unknown> {
  filters = { ...filters };
  if (selectedDuration && !isEmpty(selectedDuration)) {
    filters.foundOn = getStartAndEndDateForQuickOption({
      label: selectedDuration,
      utcString: true,
    });
  } else if (startDate && endDate) {
    filters.foundOn = [startDate, endDate];
  }
  return filters;
}
